export const projectListType = {
  MY_PROJECTS: 'myProjects',
  COMPANY_PROJECTS: 'companyProjects'
}

export const projectMembersTabOptions = {
  MEMBERS: 'members',
  TEAMS: 'teams',
  CONTACTS: 'contacts'
}

export const triggerVariantStyleOptions = {
  LEFT: 'left',
  MIDDLE: 'middle',
  RIGHT: 'right'
}
